import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IDataAlertInfo } from 'src/app/services/data/generico/generico.model';

@Component({
  selector: 'app-message-alert',
  templateUrl: './message-alert.component.html',
  styleUrls: ['./message-alert.component.scss']
})
export class MessageAlertComponent implements OnChanges {
  @Input() dataInfo: IDataAlertInfo = {} as IDataAlertInfo;
  @Input() isLayout: boolean = false;
  @Input() showClose: boolean = true;
  @Output() onAction = new EventEmitter<boolean>();
  @Output() onClose = new EventEmitter<boolean>();

  nameIcon = "";
  nameColor = "";
  show = true;

  constructor() { }

  ngOnChanges(_changes: SimpleChanges): void {
    switch (this.dataInfo.type) {
      case 'SUCCESS':
        this.nameIcon = "check-circle";
        this.nameColor = "success";
        break;
      case 'WARN':
        this.nameIcon = "info";
        this.nameColor = "warn";
        break;
      case 'INFO': 
        this.nameIcon = "info";
        this.nameColor = "info";
        break;
      default:
        break;
    }
  }

  btnAction() {
    this.onAction.emit(true);
  }

  btnClose() {
    this.show = false;
    this.onClose.emit(true);
  }
}
